<template>
  <div class="outside_wrap">
    <uni-popup ref="leadUpdate" type="bottom">
      <uni-card title="导入处方" :is-full="true" :note="true">
        <div class="gridClass">
          <ms-update-drug
            v-model="drugList"
            :prescripType="prescripType"
            :prescripClass="prescripClass"
            @updateDrugList="updateDrugList"
          />
        </div>
        <template v-slot:footer>
          <div class="footer-box" @click="confirmPrescrip">
            <span class="btn">确定</span>
          </div>
        </template>
        <template v-slot:close>
          <uni-icons type="closeempty" color="#666" @click="close" />
        </template>
      </uni-card>
    </uni-popup>
    <uni-popup ref="prescripTipPop">
      <div class="popup-wrap">
        <div class="content-wrap">
          <span class="theSon">{{ codeDesc }}</span>
        </div>
        <div class="have-know" @click="haveKnow">
          <span>我知道了</span>
        </div>
      </div>
    </uni-popup>
  </div>
</template>

<script>
import { getKeyValueText } from '@/views/funcPuzzle/utils/util.js'
import msUpdateDrug from '@/views/funcPuzzle/components/ms-update-drug/ms-update-drug.vue'
import { mapState } from 'vuex'
import { aCheckDrugStock, getDrugList } from '@/views/funcPuzzle/utils/index.js'

export default {
  components: { msUpdateDrug },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    value: {
      type: [Array, String],
      default: () => {
        return []
      }
    },
    prescripList: {
      type: [Array, String],
      default: () => {
        return []
      }
    },
    updateDrugData: {
      type: [Object, String],
      default: () => ({})
    },
    channel: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      codeDesc: '',
      prescripItem: '',
      showLeadUpdate: false,
      drugList: [],
      prescripType: '',
      prescripClass: '',
      limitConfig: null
    }
  },
  computed: {
    ...mapState(['hospitalInfo'])
  },
  watch: {
    visible(val) {
      if (val) {
        this.open()
      } else {
        this.close()
      }
    },
    value(val) {
      this.$emit('input', val)
    },
    updateDrugData(val) {
      console.log('updateDrugData', val)
      if (val) {
        this.drugList = JSON.parse(val.drugs).drugList
        let arr = []
        // 按照后端传参要求 处理arr
        arr = this.drugList.map(item => {
          return {
            drugId: item.drugID,
            drugName: item.drugName,
            drugType: item.drugType,
            amount: item.amount,
            warehouseID: val.warehouseID
          }
        })
        console.log('arr', arr)
        const params = { drugs: arr, flag: '1' }

        // 请求缓存是否充足接口
        aCheckDrugStock(params).then(rs => {
          if (rs.DrugList && rs.DrugList[0]) {
            // 给返回的DrugList 添加库存不足isLack 标识
            rs.DrugList = rs.DrugList.map((item, index) => {
              arr.filter(val => {
                if (item.drugID === val.drugId && Number(val.amount) > Number(item.stockQuantity)) {
                  rs.DrugList[index].isLack = true
                }
              })
              return item
            })
          } else if ([-1, -2].includes(rs.code) && !rs.DrugList && rs.codeDesc) {
            this.codeDesc = rs.codeDesc || rs.msg
            // 失败弹窗提示
            this.prescripTipOpen()
            return false
          }

          if (rs.DrugList && rs.DrugList[0]) {
            // 给对应药品ID的药品添加库存不足isLack 标识
            this.drugList = this.drugList.map(value => {
              rs.DrugList.filter(value2 => {
                if (value.drugID === value2.drugID) {
                  value.isLack = value2.isLack
                }
              })
              return value
            })
          }
        })
        // if (this.setDrugInfo(this.drugList)) {
        this.setDrugInfo(this.drugList).then(list => {
          this.drugList = list

          if (this.channel === 2) {
            this.drugList = this.drugList.map(item => {
              const con = { ...item.drugItem }
              item = { ...item, ...con }
              return item
            })

            this.drugList.forEach((item, index) => {
              this.changeDrug(item, index)
            })
          }
        })
        // }

        this.prescripType = val.prescripType
        this.prescripClass = val.prescripClass
      }
    },
    drugList: {
      handler(val) {},
      deep: true,
      immediate: true
    }
  },
  mounted() {
    this.fetchDrugDaysConfig()
  },
  methods: {
    getKeyValueText,
    //子组件更新
    updateDrugList(drugList) {
      console.log('this.drugList', this.drugList)
      let arr = []
      // 按照后端传参要求 处理arr
      arr = this.drugList.map(item => {
        return {
          drugId: item.drugID,
          drugName: item.drugName,
          drugType: item.drugType,
          amount: item.amount,
          warehouseID: drugList.warehouseID
        }
      })
      console.log('updateDrugList', arr)
      const params = { drugs: arr, flag: '1' }

      // 请求缓存是否充足接口
      aCheckDrugStock(params).then(rs => {
        if (rs.DrugList && rs.DrugList[0]) {
          // 给返回的DrugList 添加库存不足isLack 标识
          rs.DrugList = rs.DrugList.map((item, index) => {
            arr.filter(val => {
              if (item.drugID === val.drugId && Number(val.amount) > Number(item.stockQuantity)) {
                rs.DrugList[index].isLack = true
              }
            })
            return item
          })
        } else if ([-1, -2].includes(rs.code) && !rs.DrugList && rs.codeDesc) {
          this.codeDesc = rs.codeDesc || rs.msg
          // 失败弹窗提示
          this.prescripTipOpen()
          return false
        }

        if (rs.DrugList && rs.DrugList[0]) {
          // 给对应药品ID的药品添加库存不足isLack 标识
          this.drugList = this.drugList.map(value => {
            rs.DrugList.filter(value2 => {
              if (value.drugID === value2.drugID) {
                value.isLack = value2.isLack
              }
            })
            return value
          })
        }
      })
      // if (this.setDrugInfo(this.drugList)) {
      this.setDrugInfo(this.drugList).then(list => {
        this.drugList = list

        if (this.channel === 2) {
          this.drugList = this.drugList.map(item => {
            const con = { ...item.drugItem }
            item = { ...item, ...con }
            return item
          })

          this.drugList.forEach((item, index) => {
            this.changeDrug(item, index)
          })
        }
      })
      // }

      this.prescripType = drugList.prescripType
      this.prescripClass = drugList.prescripClass
    },
    haveKnow() {
      this.$refs.prescripTipPop.close()
    },
    prescripTipOpen() {
      this.$refs.prescripTipPop.open()
    },
    changeDrug(val, index) {
      this.drugList[index].hospitalID = val.hospitalID
      this.drugList[index].drugSpec = val.drugSpec
      this.drugList[index].refDrugID = val.id
      this.drugList[index].drugName = val.commonName
      this.drugList[index].drugPrice = val.price
      this.drugList[index].permitNO = val.permitNO
      // this.drugList[index].drugItem = val

      // this.drugList[index].useAuantity = val.mindoseUnit.split(',')[0]
      this.drugList[index].useAuantity = val.useAuantity
      this.drugList[index].drugUsage = val.drugUsage
      this.drugList[index].frequence = val.defaultFrequence
      this.drugList[index].packageNumber = val.packageNumber
      this.drugList[index].mindoseUnit = val.mindoseUnit
      this.drugList[index].measureUnit = val.measureUnit
      this.drugList[index].packageUnit = val.packageUnit
    },
    setDrugInfo(list) {
      if (!list || !list[0]) return
      const ids = list.map(item => {
        return item.drugID
      })

      return getDrugList({
        drugID: ids.join(','),
        pageNum: 1,
        pageSize: 999
      }).then(rs => {
        const data = list.map((item, i) => {
          const durg = rs.DrugList.find(f => {
            f.drugName = f.commonName
            return f.drugID === item.drugID
          })

          item.drugItem = durg
          return item
        })

        return data
      })
    },
    close() {
      if (!this.$refs.leadUpdate) {
        return false
      }
      this.$emit('update:visible', false)
      this.$refs.leadUpdate.close()
    },
    open() {
      this.$refs.leadUpdate.open()
    },
    // 导入处方确认按钮
    confirmPrescrip() {
      // 判断是否开启了用药天数配置
      if (this.limitConfig) {
        const limitDays = this.limitConfig.days
        const tmp = this.drugList.find(item => item.useDays > limitDays)
        if (tmp) {
          uni.showToast({
            title: `用药天数超过${this.limitConfig.days}天`,
            icon: 'none'
          })
          // return false

          if (this.limitConfig.isLimit === 1) {
            return false
          }
        }
      }
      console.log('this.drugList', this.drugList)
      // 校验药品数量
      const isAmountNull = this.drugList.find(item => !item.amount || item.amount === '0')
      if (isAmountNull && ['1', '2', '4', '8'].includes(this.prescripType)) {
        uni.showToast({
          title: '请填写发药数量',
          icon: 'none'
        })
        return false
      }

      // 校验药品用法
      const isDrugUsageNull = this.drugList.find(item => !item.drugUsage)
      if (isDrugUsageNull && ['1', '2', '4', '8'].includes(this.prescripType)) {
        uni.showToast({
          title: '请填写药品用法',
          icon: 'none'
        })
        return false
      }

      // 校验药品次数
      const isFrequenceNull = this.drugList.find(item => !item.frequence)
      if (isFrequenceNull && ['1', '2', '4', '8'].includes(this.prescripType)) {
        uni.showToast({
          title: '请填写用药次数',
          icon: 'none'
        })
        return false
      }

      const result = []
      this.drugList.map(item => {
        if (item.drugItem.smallPhysicSpec) {
          item.drugItem.smallPhysicSpec
            .split(';')
            .map(value => {
              if (item.useAuantity % value === 0) {
                result.push(item)
              }
            })
            .filter(val => val)
        }
      })

      let rest = []

      rest = this.drugList.filter(item => {
        const idList = result.map(v => v.drugID)
        return !idList.includes(item.drugID)
      })

      let title = ''
      let smallPhysicSpec = ''

      title = rest.map(item => {
        if (item.drugItem.smallPhysicSpec) {
          smallPhysicSpec = item.drugItem.smallPhysicSpec.split(';').map(item => {
            return '【' + item + '】'
          })
          return (
            '药品' +
            '【' +
            item.drugItem.drugName +
            '】' +
            '有以下开药规格，' +
            smallPhysicSpec +
            '，当前开的单次剂量' +
            '【' +
            item.useAuantity +
            '】' +
            '不能按整数发药；'
          )
        }
      })

      if (rest[0] && smallPhysicSpec) {
        uni.showModal({
          content: title.join('\n'),
          showCancel: false,
          buttonText: '确定',
          success: res => {
            if (res.confirm) {
              return false
            }
          }
        })
        return false
      }

      this.close()
      // let isLead = {
      //   exhibition: true,
      //   templateType: this.updateDrugData.templateType
      // }
      const isImport = {
        isImport: true,
        templateType: this.updateDrugData.templateType
      }
      this.$bus.emit('drugList', {
        val: this.drugList,
        val2: isImport
      })
    },
    // 获取用药天数限制的配置
    fetchDrugDaysConfig() {
      try {
        const config = localStorage.getItem('UseDrugDaysConfig')
        if (config) {
          this.limitConfig = JSON.parse(config)
        }
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>

<style scoped></style>
<style lang="scss" scoped>
.gridClass {
  background-color: #fff;
  height: 18.346667rem;
  overflow-y: scroll;
  // padding: 0 .64rem;
  z-index: 1100;

  .ofPatient {
    height: 18.773333rem;
    overflow-y: scroll;
  }
}

.footer-box {
  text-align: center;
  width: 686ux;
  height: 1.877333rem;
  background: #0089ff;
  border-radius: 0.938667rem;
  line-height: 1.877333rem;
  font-size: 0.682667rem;
  font-weight: 500;
  .btn {
    color: #fff;
  }
}
.popup-wrap {
  width: 10.666667rem;
  min-height: 5.546667rem;
  border-radius: 0.341333rem;
  padding: 0.64rem 0.64rem 2.773333rem 0.64rem;
  background-color: #fff;
  font-size: 0.512rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #444444;
  line-height: 0.810667rem;
  overflow: hidden;

  position: relative;
  .title-wrap {
    width: 100%;
    height: 1.92rem;
    text-align: center;
    line-height: 1.92rem;
    font-size: 0.768rem;
    color: #222222;
    font-weight: 600;
  }

  .umbra {
    position: absolute;
    bottom: 3.84rem;
    left: 0rem;
    width: 100%;
    height: 0.426667rem;
    background-color: rgba(255, 255, 255, 0.5);
    background-image: linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 1));
  }

  .content-wrap {
    height: auto;
    color: #222222;
    font-size: 0.64rem;
    margin-top: 0.426667rem;
    text-align: center;
    overflow-y: scroll;
    max-height: 17.066667rem;

    .common {
      word-wrap: break-word;
    }
  }
  .have-know {
    width: 6.4rem;
    height: 1.706667rem;
    text-align: center;
    line-height: 1.706667rem;
    color: #0089ff;
    border-radius: 0.853333rem;
    border: 0.021333rem solid #0089ff;
    position: absolute;
    left: 2.56rem;
    bottom: 0.768rem;
  }
  .protocol {
    width: 100%;
    height: 1.450667rem;
    display: flex;
    align-items: center;
    .protocol-text {
      font-size: 0.512rem;
      font-family: PingFang SC;
      font-weight: 400;
      color: #888;
    }
  }
}
</style>
